import { ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { FormSettingModel } from "projects/sepidz-web-framework/src/lib/models/formsettingmodel";
import { takeUntil } from "rxjs/operators";
import { LocalStoreManager } from "projects/sepidz-web-framework/src/lib/services";
import { ClearableCache } from "projects/sepidz-web-framework/src/lib/models/clearablecache.model";
import { CostSpentFormSettingModel } from "../costspentformsetting.model";
import { Observable } from "rxjs";
@Component({
  selector: "ngx-costspentsetting-form",
  templateUrl: "./costspentsetting-form.component.html",
  styleUrls: ["./costspentsetting-form.component.scss"],
})
export class CostspentsettingFormComponent extends BaseFormComponent<FormSettingModel> {
  costSpentformsetting: CostSpentFormSettingModel;
  _svgFillCodes: any;
  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef, public storage: LocalStoreManager) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.apiName = "CostSpentFormSetting";
    this.label = this.translate("ClientApp.FrontOffice.Cost.SpentCost.Settings");
    this.customColumnInfoApi = "CostSpentFormSetting/GetFormColumnInfo";
    this.changeNoCheck = true;

    super.ngOnInit();
    this.FillData();
  }
  FillData() {
    this.httpCommonService
      .getList("CostSpentFormSetting")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((result: any[]) => {
        if (result?.length > 0) {
          this.costSpentformsetting = result[0];
          this.storage.savePermanentData(result[0], ClearableCache.FormSetting);
        }
      });
    this.addControl();
    this._svgFillCodes = { 1: "#e0dede", 2: "#5161d0" };
  }
  refreshSetting() {
    this.httpCommonService
      .getList("CostSpentFormSetting")
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((result: any[]) => {
        if (result?.length > 0) {
          this.storage.savePermanentData(result[0], ClearableCache.FormSetting);
        }
      });
  }

  override canDeactivate(): boolean | Observable<boolean> {
    this.closeForm(true);
    return true;
  }
}
